<template>
  <div id="app">
    <div data-v-f72f4208="" class="layout">
      <div data-v-2b6ea562="" data-v-f72f4208="" class="sticky">
        <div class="logo" style="width: 90px;height: 30px;background-image: url('./static/logo.png');background-size: 100% 100%;
                              margin-right: 50px;position: absolute;top:22px;left: 10px;">
        </div>
        <div data-v-2b6ea562="" class="top-mask">
          <header data-v-2b6ea562="" class="top container">
            <div data-v-2b6ea562="" class="left">
              <a data-v-2b6ea562="" href="javascript:void();" class="router-link-active">
                <!-- <img data-v-2b6ea562="" src="static/picture/top-logo.35d8ab5d.png" -->
                <!-- alt="" class="top-logo"> -->
              </a>
            </div>
            <div data-v-2b6ea562="" class="flex">
              <!-- <div data-v-2b6ea562="" class="tabs">
                <div data-v-2b6ea562="" class="tab-item">
                  <a data-v-2b6ea562="" href="./index.html" class="">
                    首页
                  </a>
                </div>
                <div data-v-2b6ea562="" class="tab-item">
                  <a data-v-2b6ea562="" href="./demand.html" class="router-link-active">
                    需求大厅
                  </a>
                </div>
                <div data-v-2b6ea562="" class="tab-item">
                  <a data-v-2b6ea562="" href="./creators.html" class="">
                    展厅
                  </a>
                </div>
                <div data-v-2b6ea562="" class="tab-item">

                </div>
              </div> -->
              <div data-v-2b6ea562="" class="right">
                <!---->
                <div data-v-2b6ea562="" class="action-box">
                  <div data-v-2b6ea562="" class="pointer rapid">
                    <a data-v-2b6ea562="" href="./demand.html" class="">
                      接单
                    </a>
                  </div>
                  <div data-v-2b6ea562="" class="pointer rapid">
                    <a data-v-2b6ea562="" href="./publish.html" class="">
                      发布申请
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </header>
        </div>
        <div data-v-4c6d260d="" data-v-2b6ea562="" class="overlay" style="z-index: 99999; display: none;">
          <div data-v-2b6ea562="" class="wrapper">
            <!---->
          </div>
        </div>
      </div>
      <div data-v-f72f4208="" class="main-content">
        <div data-v-6e561b88="" data-v-f72f4208="" class="p-detail">
          <header data-v-6e561b88="" class="container">
            <div data-v-6e561b88="" class="left">
              <div data-v-6e561b88="" class="title">
                <div data-v-6e561b88="" class="l-title">
                  <div data-v-6e561b88="" class="describe" style="background: rgb(113, 231, 198);">
                    招募中
                  </div>
                  <!---->
                  <!---->
                  <div data-v-6e561b88="" class="text" style="flex: 1 1 0%;">
                    <!-- 江苏少年儿童出版社治愈儿童系列小说插画 -->
                    [商业需求] <font id="title1">{{ currentItem.title }} </font>
                  </div>
                </div>
                <div data-v-6e561b88="" class="r-title">
                  <i data-v-6e561b88="">
                    <font id="price1">{{ currentItem.price }}</font>
                  </i>
                  元/张
                </div>
              </div>
              <div data-v-6e561b88="" class="sec">
                <div data-v-6e561b88="" class="tags">
                  <div data-v-6e561b88="" class="tag-item">

                  </div>
                  <div data-v-6e561b88="" class="tag-item">

                  </div>
                </div>
                <div data-v-6e561b88="" class="end" style="padding-left: 15px;">
                  稿件数量： <font id="num1">{{ currentItem.number }} </font>
                </div>
              </div>
              <div data-v-6e561b88="" class="bottom">
                <div data-v-6e561b88="" class="time">

                </div>
                <div data-v-6e561b88="" class="end" style="padding-left: 15px;">
                  期望交稿日期： <font id="data1">{{ currentItem.date }}</font>
                </div>
              </div>
              <div data-v-6e561b88="" class="price"></div>
            </div>
            <div data-v-6e561b88="" class="right">

            </div>
          </header>
          <main data-v-6e561b88="" class="container">
            <div data-v-6e561b88="" class="m-left">
              <div data-v-6e561b88="" class="recruit-progress-box">
                <div data-v-6e561b88="" class="progress-title">
                  招募进程
                </div>
                <div data-v-6e561b88="" class="progress">
                  <div data-v-6e561b88="" class="progress-item">
                    <div data-v-6e561b88="" class="box" style="background-color: rgb(94, 213, 200);"></div>
                    <div data-v-6e561b88="" class="label">
                      <!---->
                      <span data-v-6e561b88="" style="color: rgb(94, 213, 200);">
                        发布需求
                      </span>
                    </div>
                  </div>
                  <div data-v-6e561b88="" class="progress-item">
                    <div data-v-6e561b88="" class="box" style="background-color: rgb(113, 231, 198);"></div>
                    <div data-v-6e561b88="" class="label">
                      <span data-v-6e561b88="" class="sign"
                        style="background: radial-gradient(circle closest-side, rgb(113, 231, 198) 50%, rgba(113, 231, 198, 0.5) 50%);"></span>
                      <span data-v-6e561b88="" style="color: rgb(113, 231, 198);">
                        招募中
                      </span>
                    </div>
                  </div>
                  <div data-v-6e561b88="" class="progress-item">
                    <div data-v-6e561b88="" class="box"></div>
                    <div data-v-6e561b88="" class="label">
                      <!---->
                      <span data-v-6e561b88="">
                        项目合作中
                      </span>
                    </div>
                  </div>
                  <div data-v-6e561b88="" class="progress-item">
                    <div data-v-6e561b88="" class="box"></div>
                    <div data-v-6e561b88="" class="label">
                      <!---->
                      <span data-v-6e561b88="">
                        项目已结束
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-6e561b88="">
                <div data-v-6e561b88="" class="photos">

                  <div data-v-6e561b88="" class="p-info">
                    <div data-v-6e561b88="" class="title">
                      创作要求
                    </div>
                    <div data-v-6e561b88="" class="info-detail">
                      <div data-v-6e561b88="" class="item">
                        <div data-v-6e561b88="" class="name">
                          试稿
                        </div>
                        <div data-v-6e561b88="" class="na">
                          无需试稿
                        </div>
                      </div>
                      <div data-v-6e561b88="" class="item">
                        <div data-v-6e561b88="" class="name">
                          作品方向
                        </div>
                        <div data-v-6e561b88="" class="na">
                          出版物
                        </div>
                      </div>
                      <div data-v-6e561b88="" class="item">
                        <div data-v-6e561b88="" class="name">
                          用途类型
                        </div>
                        <div data-v-6e561b88="" class="na">
                          绘本
                        </div>
                      </div>
                      <div data-v-6e561b88="" class="item">
                        <div data-v-6e561b88="" class="name">
                          创作方式
                        </div>
                        <div data-v-6e561b88="" class="na">
                          手绘
                        </div>
                        <div data-v-6e561b88="" class="na">
                          板绘
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-v-6e561b88="" class="p-info">
                    <div data-v-6e561b88="" class="title">
                      其他要求
                    </div>
                    <div data-v-6e561b88="" class="info-detail">
                      <div data-v-6e561b88="" class="item">
                        <div data-v-6e561b88="" class="name">
                          稿件数量
                        </div>
                        <div data-v-6e561b88="" class="na">
                          <font id="num2">{{ currentItem.number }}</font> 张
                        </div>
                      </div>
                      <div data-v-6e561b88="" class="item">
                        <div data-v-6e561b88="" class="name">
                          稿件尺寸
                        </div>
                        <div data-v-6e561b88="" class="na">
                          2000px以上
                        </div>
                      </div>
                      <div data-v-6e561b88="" class="item">
                        <div data-v-6e561b88="" class="name">
                          薪酬区间
                        </div>
                        <div data-v-6e561b88="" class="na">
                          <font id="price2">{{ currentItem.price }}</font> 元/张
                        </div>
                      </div>
                      <div data-v-6e561b88="" class="item">
                        <div data-v-6e561b88="" class="name">
                          稿件格式
                        </div>
                        <div data-v-6e561b88="" class="na">
                          PSD
                        </div>
                      </div>
                      <div data-v-6e561b88="" class="item">
                        <div data-v-6e561b88="" class="name">
                          稿件颜色模式
                        </div>
                        <div data-v-6e561b88="" class="na">
                          CMYK
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-v-6e561b88="" class="el-image img">

                  </div>
                 <el-button @click="open">接单</el-button>
                </div>
              </div>
            </div>
            <div data-v-6e561b88="" class="m-right">
              <div data-v-6e561b88="" class="apply-box">
                <div data-v-6e561b88="" class="title" onclick="baojia()">

                </div>
                <div data-v-6e561b88="" class="desc">

                </div>

              </div>

            </div>
          </main>
          <!---->

        </div>
      </div>


    </div>
    <!---->
    <!---->
  </div>
</template>

<script>
import axios from "axios";
import { information_listApi, take_informationApi } from "../api/index";
export default {
  data() {
    return {
      date:'',
      currentItem:{},
      params: {
        page: {
          page_num: 1,
          page_limit: 10
        },
        map: { "title": "" },
      }
    }
  },
  created(){
    // this.date = this.$route.query.date
    this.params.map.title = this.$route.query.date
    this.getPublishById()
  },
  methods:{
    async getPublishById() {
      const res = await information_listApi(this.params)
      if (res.data.code === 1) {
        this.currentItem = res.data.data[0]
      }
    },
    open() {
      this.$confirm('您是否确定接此单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await take_informationApi({ id: this.currentItem.id })
        if (res.data.code === 1) {
          this.$message({
            type: 'success',
            message: '接单成功'
          });
        }else{
          this.$message({
            type: 'error',
            message: res.data.msg
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>



.progress{
  background-color: #ffffff;
  height: 100px;
}
.applyform[data-v-05bfbd0e] .el-input {
  width: 100%
}

.applyform[data-v-05bfbd0e] .el-input__suffix {
  padding-right: 5px
}

.applyform .line[data-v-05bfbd0e] {
  margin: 0;
  margin-bottom: 10px
}

.applyform[data-v-05bfbd0e] .el-dialog__body {
  padding: 0
}

.applyform .el-form-item[data-v-05bfbd0e] {
  width: 100%;
  padding-left: 20px;
  margin-bottom: 10px
}

.applyform .el-form-item[data-v-05bfbd0e] .el-form-item__label {
  text-align: left;
  line-height: 30px
}

.applyform .el-form-item[data-v-05bfbd0e] .el-form-item__content {
  width: 350px
}

.applyform .el-form-item[data-v-05bfbd0e]:last-child {
  width: 100%
}

.applyform .el-form-item[data-v-05bfbd0e]:last-child .el-form-item__content {
  width: 189px
}

.applyform .el-button[data-v-05bfbd0e] {
  margin: 30px;
  margin-left: -30px
}

.applyform .price[data-v-05bfbd0e] {
  position: relative
}

.applyform .price .intro[data-v-05bfbd0e] {
  width: 200px;
  position: absolute;
  top: -39px;
  right: -75px;
  color: #e05c49;
  font-size: 12px
}

.applyform .price .sum[data-v-05bfbd0e] {
  width: 200px;
  position: absolute;
  top: 0;
  left: 160px;
  font-size: 14px;
  color: #999
}

.applyform .price .explain[data-v-05bfbd0e] {
  width: 200px;
  position: absolute;
  bottom: -33px;
  right: -70px;
  color: #999;
  font-size: 12px
}

.applyform .day[data-v-05bfbd0e] {
  position: relative
}

.applyform .day .intro[data-v-05bfbd0e] {
  position: absolute;
  top: -38px;
  right: 0;
  color: #e05c49;
  font-size: 12px;
  letter-spacing: 1px
}

.upload-box .img-box[data-v-05bfbd0e] {
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap
}

.upload-box .img-box[data-v-05bfbd0e],
.upload-box .upload-add[data-v-05bfbd0e] {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center
}

.upload-box .upload-add[data-v-05bfbd0e] {
  -webkit-justify-content: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border: 1px solid #eee;
  border-radius: 3px;
  margin-right: 5px
}

.upload-box .img-item[data-v-05bfbd0e] {
  position: relative;
  width: 100px;
  height: 100px;
  margin-right: 20px;
  margin-bottom: 10px
}

.upload-box .img-item .delete[data-v-05bfbd0e] {
  position: absolute;
  top: -4px;
  right: -5px;
  color: #cfcfcf
}

.upload-box .img-item img[data-v-05bfbd0e] {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover
}

[data-v-05bfbd0e] .el-upload--picture-card {
  width: 100px;
  height: 100px
}

.desc[data-v-05bfbd0e] {
  font-size: 12px;
  color: #999
}

.totalprice[data-v-05bfbd0e] {
  border-top: 1px solid #dedede;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  margin: 0 20px;
  padding: 20px 0;
  color: #333;
  font-size: 15px
}

.totalprice .pri[data-v-05bfbd0e] {
  color: #e05c49
}

.dialog-content[data-v-05bfbd0e] {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  align-items: center;
  padding-top: 30px
}

.dialog-content .icon[data-v-05bfbd0e] {
  font-size: 100px;
  color: #e05c49
}

.dialog-content .text1[data-v-05bfbd0e] {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  padding-top: 30px;
  padding-bottom: 30px
}

.dialog-content .text2[data-v-05bfbd0e] {
  font-size: 14px;
  color: #666;
  padding-bottom: 10px
}

.dialog-content .c-btn[data-v-05bfbd0e] {
  width: 200px;
  margin-top: 40px;
  margin-bottom: 40px;
  margin: 50px 0 100px
}

[data-v-dc4262d8] .el-dialog__header {
  padding: 20px;
  padding-bottom: 10px
}

[data-v-dc4262d8] .el-dialog__body {
  padding: 0
}

.title[data-v-dc4262d8] {
  font-size: 16px;
  font-weight: 500;
  color: #333
}

.s-title[data-v-dc4262d8] {
  font-size: 14px;
  padding: 10px 0;
  color: #333
}

.content[data-v-dc4262d8] {
  margin: 20px;
  background-color: #f9fafc;
  padding: 30px 15px;
  max-height: 360px;
  overflow: scroll
}

.content .text[data-v-dc4262d8] {
  color: #999
}

.p-detail[data-v-6e561b88] {
  width: 100%;
  padding-top: 10px;
  background: #f9fafc
}

header[data-v-6e561b88] {
  width: 100%;
  border: 1px solid transparent;
  padding: 23px 0;
  background: #fff;
  margin-bottom: 10px;
  display: -webkit-flex;
  display: flex
}

header .left[data-v-6e561b88] {
  position: relative;
  width: 70%;
  padding-left: 20px;
  border-right: thin solid #dedede
}

header .left .title[data-v-6e561b88] {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-flex-shrink: 0;
  flex-shrink: 0
}

header .left .title .l-title[data-v-6e561b88] {
  -webkit-flex: 1;
  flex: 1;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-flex-shrink: 0;
  flex-shrink: 0
}

header .left .title .r-title[data-v-6e561b88] {
  padding-right: 50px;
  color: #e05c49
}

header .left .title .r-title i[data-v-6e561b88] {
  font-size: 30px
}

header .left .title .text[data-v-6e561b88] {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-right: 13px
}

header .left .title .describe[data-v-6e561b88] {
  width: 69px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: #e05c49;
  border-radius: 14px 0 14px 0;
  font-size: 12px;
  color: #fff;
  margin-right: 10px
}

header .left .sec[data-v-6e561b88] {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  padding-right: 50px;
  margin: 6px 0 14px
}

header .left .sec .end[data-v-6e561b88] {
  color: #999
}

header .left .tags[data-v-6e561b88] {
  width: 65%;
  display: -webkit-flex;
  display: flex
}

header .left .tags .tag-item[data-v-6e561b88] {
  display: -webkit-flex;
  display: flex;
  font-size: 12px;
  color: #999
}

header .left .tags .tag-item:last-child .devide[data-v-6e561b88] {
  display: none
}

header .left .tags .devide[data-v-6e561b88] {
  margin: 0 10px
}

header .left .bottom[data-v-6e561b88] {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  position: relative;
  font-size: 12px;
  color: #333;
  font-weight: 500
}

header .left .bottom .time[data-v-6e561b88] {
  margin-right: 20px
}

header .left .price[data-v-6e561b88] {
  text-align: right;
  position: absolute;
  bottom: 43px;
  right: 54px;
  font-weight: 500;
  color: #e05c49
}

header .left .price i[data-v-6e561b88] {
  font-size: 30px;
  color: #e05c49
}

header .left .price .end[data-v-6e561b88] {
  margin-top: 8px;
  color: #999
}

header .right[data-v-6e561b88] {
  width: 30%;
  display: -webkit-flex;
  display: flex
}

header .right img[data-v-6e561b88] {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  -o-object-fit: cover;
  object-fit: cover;
  margin: 10px 26px 0 48px
}

header .right .user[data-v-6e561b88] {
  -webkit-flex: 1;
  flex: 1;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-justify-content: space-around;
  justify-content: space-around;
  padding: 15px 0
}

header .right .user .name[data-v-6e561b88] {
  width: 80%;
  font-size: 18px;
  color: #333;
  font-weight: 600;
  margin-bottom: 8px
}

header .right .user .tags[data-v-6e561b88] {
  display: -webkit-flex;
  display: flex
}

header .right .user .tags .tag-item[data-v-6e561b88] {
  display: -webkit-flex;
  display: flex;
  font-size: 14px;
  color: #999
}

header .right .user .tags .tag-item:last-child .devide[data-v-6e561b88] {
  display: none
}

header .right .user .tags .devide[data-v-6e561b88] {
  margin: 0 5px
}

main[data-v-6e561b88] {
  display: -webkit-flex;
  display: flex
}

main .m-left[data-v-6e561b88] {
  width: 75%;
  margin-right: 10px
}

main .m-left .photos[data-v-6e561b88] {
  background-color: #fff;
  margin-bottom: 100px;
  padding: 40px 20px 40px
}

main .m-left .photos .img[data-v-6e561b88] {
  width: 690px;
  -o-object-fit: cover;
  object-fit: cover
}

main .m-left .photos .content[data-v-6e561b88] {
  font-size: 14px;
  color: #666
}

main .m-left .photos .p-info .title[data-v-6e561b88] {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  padding-left: 11px;
  margin: 18px 0;
  border-left: 6px solid #e05c49
}

main .m-left .photos .p-info .info-detail[data-v-6e561b88] {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap
}

main .m-left .photos .p-info .info-detail .item[data-v-6e561b88] {
  width: 300px;
  display: -webkit-flex;
  display: flex;
  margin-bottom: 15px;
  margin-right: 30px
}

main .m-left .photos .p-info .info-detail .item .name[data-v-6e561b88] {
  width: 100px;
  font-size: 14px;
  color: #999
}

main .m-left .photos .p-info .info-detail .item .na[data-v-6e561b88] {
  font-size: 14px;
  line-height: 20px;
  color: #333;
  margin-right: 8px
}

main .m-right[data-v-6e561b88] {
  width: 25%
}

.m-right .visitor[data-v-6e561b88] {
  margin-bottom: 17px;
  padding: 20px 15px;
  background-color: #fff
}

.m-right .visitor .title[data-v-6e561b88] {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  letter-spacing: 1px;
  margin-bottom: 35px
}

.m-right .visitor .list .list-item[data-v-6e561b88] {
  margin-bottom: 10px;
  text-align: center
}

.m-right .visitor .list .list-item img[data-v-6e561b88] {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  -o-object-fit: cover;
  object-fit: cover
}

.m-right .visitor .list .list-item .name[data-v-6e561b88] {
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #333
}

.m-right .visitor .placeholder-img[data-v-6e561b88] {
  text-align: center
}

.m-right .visitor .placeholder-img img[data-v-6e561b88] {
  width: 120px
}

.m-right .visitor .placeholder-img p[data-v-6e561b88] {
  color: #333;
  font-size: 10px
}

.addclass[data-v-6e561b88] {
  position: absolute;
  right: 48px;
  text-align: right;
  margin-bottom: 3px
}

.addclass i[data-v-6e561b88] {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  color: #fff
}

.addclass1[data-v-6e561b88] {
  background-color: #00d7ee
}

.addclass2[data-v-6e561b88] {
  background-color: #b8b8b8
}

[data-v-6e561b88] .el-image-viewer__wrapper .el-image-viewer__close {
  background-color: #fff;
  color: #999
}

.recruit-progress-box[data-v-6e561b88] {
  padding: 20px;
  background-color: #fff;
  margin-bottom: 10px
}

.recruit-progress-box .progress-title[data-v-6e561b88] {
  font-size: 18px;
  font-weight: 600;
  padding-bottom: 20px
}

.recruit-progress-box .progress[data-v-6e561b88] {
  display: -webkit-flex;
  display: flex
}

.recruit-progress-box .progress-item[data-v-6e561b88] {
  -webkit-flex: 1;
  flex: 1;
  margin-right: 1px;
  text-align: center
}

.recruit-progress-box .progress-item .box[data-v-6e561b88] {
  height: 10px;
  background-color: #eee
}

.recruit-progress-box .progress-item .label[data-v-6e561b88] {
  position: relative;
  display: inline-block;
  font-size: 14px;
  color: #999;
  padding-top: 14px
}

.recruit-progress-box .progress-item .label .sign[data-v-6e561b88] {
  font-size: 16px;
  font-weight: 600;
  color: #86bf55;
  position: absolute;
  left: -18px;
  top: 50%;
  width: 13px;
  height: 13px;
  border-radius: 50%
}

.apply-box[data-v-6e561b88] {
  padding: 20px 15px;
  background-color: #fff;
  margin-bottom: 10px
}

.apply-box .title[data-v-6e561b88] {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding-bottom: 9px
}

.apply-box .desc[data-v-6e561b88] {
  font-size: 12px;
  padding-bottom: 55px
}

.apply-box .btn[data-v-6e561b88] {
  width: 100%
}
</style>
